import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

import DashboardIndex from './views/dashboard/DashboardIndex'

import /* webpackChunkName: "LmRouterView" */ LmRouterView from '@/components/LmRouterView'
import /* webpackChunkName: "LmList" */ LmList from '@/components/LmList'
import /* webpackChunkName: "LmListV2" */ LmListV2 from '@/components/LmListV2'
import /* webpackChunkName: "VueFormulatePage" */ VueFormulatePage from '@/views/VueFormulatePage'
import /* webpackChunkName: "LmFormBuilder" */ LmFormBuilder from '@/components/LmFormBuilder.vue'
import /* webpackChunkName: "NewOrEdit" */ NewOrEdit from '@/views/coupons/NewOrEdit'
import /* webpackChunkName: "calendar" */ DashboardHome from '@/views/dashboard/DashboardHome'
import /* webpackChunkName: "LmNewOrEdit" */ LmNewOrEdit from '@/components/LmNewOrEdit'
import /* webpackChunkName: "LmDashboard" */ LmDashboard from '@/components/LmDashboard.vue'

// XXX: Estas views que se importan son temporales y solo aplican para MVL Mesa3 en un futuro
// van a dejar de cargarse en lumbre y van a pasar a ser componentes

// MESA
import /* webpackChunkName: "MesaUserProfile" */ MesaUserProfile from '@/views/mvlmesa/usuarios/MesaUserProfile'
import /* webpackChunkName: "MesaLicencias" */ MesaLicencias from '@/views/mvlmesa/licencias/MesaLicencias'
import /* webpackChunkName: "ExpedientesNewOrEdit" */ ExpedientesNewOrEdit from '@/views/mvlmesa/expedientes/ExpedientesNewOrEdit'
import /* webpackChunkName: "NotasNewOrEdit" */ NotasNewOrEdit from '@/views/mvlmesa/expedientes/NotasNewOrEdit'
import /* webpackChunkName: "RemitosNewOrEdit" */ RemitosNewOrEdit from '@/views/mvlmesa/remitos/RemitosNewOrEdit'
import /* webpackChunkName: "RemitosDetalle" */ RemitosDetalle from '@/views/mvlmesa/remitos/RemitosDetalle'
import /* webpackChunkName: "RemitosConfirmar" */ RemitosConfirmar from '@/views/mvlmesa/remitos/RemitosConfirmar'
import /* webpackChunkName: "PasesNewOrEdit" */ PasesNewOrEdit from '@/views/mvlmesa/pases/PasesNewOrEdit'
import /* webpackChunkName: "PasesAnular" */ PasesAnular from '@/views/mvlmesa/pases/PasesAnular'
import /* webpackChunkName: "PasesInternosAsignar" */ PasesInternosAsignar from '@/views/mvlmesa/pasesinternos/PasesInternosAsignar'
import /* webpackChunkName: "PasesInternosCerrar" */ PasesInternosCerrar from '@/views/mvlmesa/pasesinternos/PasesInternosCerrar'
import /* webpackChunkName: "PasesInternosAnular" */ PasesInternosAnular from '@/views/mvlmesa/pasesinternos/PasesInternosAnular'
import /* webpackChunkName: "DocumentosNewOrEdit" */ DocumentosNewOrEdit from '@/views/mvlmesa/documentos/DocumentosNewOrEdit'
import /* webpackChunkName: "DocumentosAsociadosNewOrEdit" */ DocumentosAsociadosNewOrEdit from '@/views/mvlmesa/documentos/DocumentosAsociadosNewOrEdit'
import /* webpackChunkName: "DocumentoAFirmarNewOrEdit" */ DocumentoAFirmarNewOrEdit from '@/views/mvlmesa/documentos/DocumentoAFirmarNewOrEdit'
import /* webpackChunkName: "CaratulaExpediente" */ CaratulaExpediente from '@/views/mvlmesa/documentos/CaratulaExpediente'
import /* webpackChunkName: "GireseExpediente" */ GireseExpediente from '@/views/mvlmesa/documentos/GireseExpediente'
import /* webpackChunkName: "TemplateNewOrEdit" */ TemplateNewOrEdit from '@/views/mvlmesa/templates/TemplateNewOrEdit'
import /* webpackChunkName: "DecretosNewOrEdit" */ DecretosNewOrEdit from '@/views/mvlmesa/decretos/DecretosNewOrEdit'
import /* webpackChunkName: "DecretosFirmar" */ DecretosFirmar from '@/views/mvlmesa/decretos/DecretosFirmar'
import /* webpackChunkName: "UsuariosNewOrEdit" */ UsuariosNewOrEdit from '@/views/mvlmesa/usuarios/UsuariosNewOrEdit'
import /* webpackChunkName: "NotificacionesNewOrEdit" */ NotificacionesNewOrEdit from '@/views/mvlmesa/notificaciones/NotificacionesNewOrEdit'
import /* webpackChunkName: "MesaDelegacionesConsultas" */ MesaDelegacionesConsultas from '@/views/mvlmesa/delegaciones/MesaDelegacionesConsultas'

// CEMENTERIO

// 365
import /* webpackChunkName: "PreciosVigentesNewOrEdit" */ PreciosVigentesNewOrEdit from '@/views/365/pages/PreciosVigentesNewOrEdit.vue'
import /* webpackChunkName: "PreciosVigentesNewOrEdit" */ HomeNewOrEdit from '@/views/365/pages/HomeNewOrEdit.vue'
import /* webpackChunkName: "SorteosNewOrEdit" */ SorteosNewOrEdit from '@/views/365/pages/SorteosNewOrEdit.vue'
import /* webpackChunkName: "NomenclaturasDetail" */ NomenclaturasDetail from '@/views/mvlcementerio/nomenclaturas/NomenclaturasDetail'
import /* webpackChunkName: "LandingPagesNewOrEdit" */ LandingPagesNewOrEdit from '@/views/365/landings/LandingPagesNewOrEdit.vue'

// https://github.com/lumile/lumbre/issues/604
// Credits: https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
const b64DecodeUnicode = function (str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
}

const vueComponents = {
  LmRouterView,
  LmList,
  LmListV2,
  VueFormulatePage,
  LmFormBuilder,
  NewOrEdit,
  MesaUserProfile,
  MesaLicencias,
  ExpedientesNewOrEdit,
  NotasNewOrEdit,
  RemitosNewOrEdit,
  RemitosDetalle,
  RemitosConfirmar,
  PasesNewOrEdit,
  PasesAnular,
  PasesInternosAsignar,
  PasesInternosCerrar,
  PasesInternosAnular,
  DocumentosNewOrEdit,
  DocumentosAsociadosNewOrEdit,
  DocumentoAFirmarNewOrEdit,
  CaratulaExpediente,
  GireseExpediente,
  TemplateNewOrEdit,
  DecretosNewOrEdit,
  DecretosFirmar,
  UsuariosNewOrEdit,
  NotificacionesNewOrEdit,
  NomenclaturasDetail,
  DashboardHome,
  LmDashboard,
  LmNewOrEdit,
  PreciosVigentesNewOrEdit,
  HomeNewOrEdit,
  SorteosNewOrEdit,
  LandingPagesNewOrEdit,
  MesaDelegacionesConsultas
}

Vue.use(Router)

class MetaBreadcrumb {
  constructor (name, to) {
    this.name = name
    this.to = to
  }
}

export async function createRouter () {
  let routerConfig = {
    mode: 'history',
    routes: [
      {
        path: '/',
        name: 'dashboard_index',
        component: DashboardIndex,
        meta: {
          breadcrumb: new MetaBreadcrumb('Dashboard', '/')
        },
        children: [
          {
            path: '',
            name: 'dashboard_home',
            meta: {
              title: 'Dashboard'
            },
            component: () => import(/* webpackChunkName: "calendar" */ '@/views/dashboard/DashboardHome.vue')
          },
          {
            path: '/form',
            name: 'form',
            meta: {
              title: 'Fom'
            },
            component: () => import(/* webpackChunkName: "form" */ '@/views/Form.vue')
          },
          {
            path: '/vueformulatepage',
            name: 'VueFormulatePage',
            meta: {
              title: 'VueFormulatePage'
            },
            component: () => import(/* webpackChunkName: "VueFormulatePage" */ '@/views/VueFormulatePage.vue')
          },
          {
            path: '/refactored-expedientes-form',
            name: 'newExpedientesNewOrEdit',
            meta: {
              title: 'refactoredExpedientesNewOrEdit'
            },
            component: () => import(/* webpackChunkName: "refactored" */ '@/views/mvlmesa/expedientes/refactoredExpedientesNewOrEdit.vue')
          },
          {
            path: '/draggable',
            name: 'draggable',
            meta: {
              title: 'draggable'
            },
            component: () => import(/* webpackChunkName: "refactored" */ '@/views/mvlmesa/draggable/index.vue')
          }
        ]
      },
      {
        path: '/login',
        name: 'login',
        meta: {
          title: 'Login'
        },
        component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
      },
      {
        path: '/callback',
        name: 'callback',
        component: () => import(/* webpackChunkName: "callback" */ '@/views/Callback.vue')
      },
      {
        path: '/no-permitido',
        name: '401',
        component: () => import(/* webpackChunkName: "404" */ '@/views/401.vue')
      },
      {
        path: '*',
        name: '404',
        component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue')
      }
    ]
  }

  // Se cargan las rutas dinamicamente desde el endpoint de la API
  try {
    let apiResponse = await axios.get('settings/routesconfig/')
    // Si en la respuesta el valor `h` está seteado a true el valor de routesConfigs esta
    // encodeado en base64
    if (apiResponse?.data?.h === true) {
      let decodedRoutes = apiResponse.data.routesConfigs.split(':')
      decodedRoutes = b64DecodeUnicode(decodedRoutes[1])
      apiResponse.data.routesConfigs = JSON.parse(decodedRoutes)
    }
    if (Array.isArray(apiResponse?.data?.routesConfigs)) {
      let useCustomUserProfileRoute = false
      apiResponse.data.routesConfigs.forEach(newRoute => {
        if (newRoute.component in vueComponents) {
          newRoute.component = vueComponents[newRoute.component]
          // Si el endpoint nos retorna una ruta con name 'user-profile'
          // la usamos en vez del user-profile por defecto de lumbre
          if (newRoute?.name === 'user-profile') {
            useCustomUserProfileRoute = true
          }
          if (newRoute?.meta?.breadcrumb) {
            newRoute.meta.breadcrumb = new MetaBreadcrumb(newRoute.meta.breadcrumb)
          }
          if (Array.isArray(newRoute?.children)) {
            newRoute.children = newRoute.children.map(child => {
              child.component = vueComponents[child.component]
              return child
            })
          }
          routerConfig.routes[0].children.push(newRoute)
        }
      })
      if (!useCustomUserProfileRoute) {
        // Si la api no definio ninguna pagina de perfil usamos una generica.
        routerConfig.routes[0].children.push({
          path: '/user-profile',
          name: 'user-profile',
          component: () => import(/* webpackChunkName: "user-profile" */ '@/views/LmUserProfile.vue')
        })
      }
    }
  } catch (error) {
    console.log(error)
  }

  return new Router(routerConfig)
}
